var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiny-check tappable",on:{"click":_vm.triggerClick}},[(_vm.isTrue)?_c('i',{staticClass:"fa ok fa-check-square-o",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-square-o",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }